import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type ToggleActivePayload = {
  id: EntityId
}

export const toggleDepotStatus = createAsyncThunk('depots/toggleActive', async ({ id }: ToggleActivePayload) => {
  const results = await OLMSApiService.post<number>('/depot/toggleActive', id)

  return results
})